import {Organisation, OrganisationBox, OrganisationUser} from '../common/types/organisation'
import {Role} from '../common/types/role'
import {GQL_OrganisationBoxFragment, GQL_OrganisationFragment, GQL_OrganisationUserFragment} from '../generated/graphql'
import {transformBoxColor} from './transformBox'
import {transformLocation} from './transformLocation'
import {transformRole} from './transformRole'

export const transformOrganisationUser = (user: GQL_OrganisationUserFragment): OrganisationUser => ({
  id: user.id,
  email: user.email ?? undefined,
  firstName: user.firstName ?? undefined,
  lastName: user.lastName ?? undefined,
  roles: (user.roles ?? []).map((r) => transformRole(r) as Role),
})

export const transformOrganisationBox = (box: GQL_OrganisationBoxFragment): OrganisationBox => ({
  id: box.id,
  location: transformLocation(box.location),
  name: box.name,
  contractType: box.contractType ?? null,
  color: transformBoxColor(box.color),
})

export const transformOrganisation = (organisation: GQL_OrganisationFragment): Organisation => ({
  id: organisation.id,
  name: organisation.name,
  city: organisation.city ?? undefined,
  contactEmail: organisation.contactEmail,
  contactName: organisation.contactName,
  country: organisation.country ?? undefined,
  phoneNumber: organisation.phoneNumber ?? undefined,
  zipCode: organisation.zipCode ?? undefined,
  archivedAt: organisation.archivedAt ?? null,
  contractTypes: organisation.contractTypes ?? [],
  users: organisation.users.map(transformOrganisationUser),
  boxes: organisation.boxes.map(transformOrganisationBox),
})
